import { useContext } from "react";
import { LobbySettingsContext } from "../../../entities/lobby";

export function useLobbyLoader() {
  return useContext(LobbySettingsContext).Loader;
}

export function useLobbyLogo() {
  return useContext(LobbySettingsContext).Logo;
}

export function useLobbySpinner() {
  return useContext(LobbySettingsContext).Spinner;
}

export function useLobbyCloseBtn() {
  return useContext(LobbySettingsContext).CloseBtn;
}
